import { render, staticRenderFns } from "./DateOfBirth.vue?vue&type=template&id=ba12e262"
import script from "./DateOfBirth.vue?vue&type=script&lang=ts"
export * from "./DateOfBirth.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports